import { gql } from '@apollo/client';

export const ALL_LEARNING_OBJECT_TAGS_QUERY = gql`
    query learningObjects {
        objects {
            edges {
                node {
                    id
                    tags
                }
            }
        }
    }
`;
